// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"3fa18211","109":"6975b383","973":"b79c5d5a"}[chunkId] + ".chunk.css";
};